module.exports = __webpack_public_path__ + "img/farewell_9.f950614b.jpg";